import debounce from './debounce';

var stickyNavbar = debounce( function() {

    if ( screen.width > 766 ) {
        return;
    }
    //Classnames
    var stickyClass        = 'body--nav-bar-is-sticky';
    var stickyVisibleClass = 'body--nav-bar-is-sticky--visible';

    //Elements
    var body               = document.querySelector( 'body' );
    var header             = document.querySelector( '.header' );

    //Heights
    var headerHeight       = header.clientHeight;

    //Positions
    var headerY            = header.offsetTop;
    var scrollY            = this.scrollY;

    //Check when the header dissapears on top
    var headerAboveTop     = headerY < scrollY - headerHeight;

    //Add sticky class when header dissapears on top
    if ( headerAboveTop ) {
        body.classList.add( stickyClass );
    } else {
        body.classList.remove( stickyClass );
    }

    //Add visible class when scrolling up
    if ( this.oldScroll > scrollY && headerAboveTop ) {
        body.classList.add( stickyVisibleClass );
    } else {
        body.classList.remove( stickyVisibleClass );
    }

    this.oldScroll = scrollY; //Save old scroll position

}, 150 );

window.addEventListener( 'scroll', stickyNavbar );
window.addEventListener( 'resize', stickyNavbar );
